import styled from "styled-components";
import { units } from "@m/alchemy-theme";
import { RequiredFieldIndicator } from "../required-field-indicator/RequiredFieldIndicator";
import { Label } from "../field-label/FieldLabel.styled";
export const Fieldset = styled.fieldset `
  & > legend {
    padding-bottom: ${units(0.25)};
    position: relative;
  }

  margin-bottom: ${units(3)};
  position: relative;
`;
export const RequiredIndicator = styled(RequiredFieldIndicator) `
  position: absolute;
  left: ${units(-1)};
  top: ${units(0.5)};
`;
export const Legend = styled(Label).attrs({ as: "legend" }) ``;
